export default __webpack_public_path__ + "static/media/03.8e3664d7.jpg";